module.exports = __webpack_public_path__ + "img/onboarding-header-light.e4bfa1d3.svg";